module.exports = __webpack_public_path__ + "media/images/pages/tnc_logo-fdd0c9fd51880290913c5b9950e36821.png";